import {makeStyles} from "@material-ui/core";

export default function SectionCss() {
    return makeStyles(theme => ({
        header:{
            display: "flex",
            width: '100%',
        },
        title: {
            padding: "12px",
        },
        iconButton: {
            marginLeft: "auto"
        },
        container: {
            flexWrap: 'wrap',
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        textField: {
            width: '100%',
        },
        multilineColor: {
            color: theme.palette.text.secondary,
            borderBottomColor: theme.palette.primary,
            "&::after": {
                borderBottomColor: theme.palette.primary,
            }
        },
        buttonAction: {
            marginTop: 30,
            width: '100%'
        },
        buttonCancelar: {
            color: theme.palette.text.secondary,
            marginRight: '10px',
        },
        icon: {
            '&:hover': {
                color: theme.palette.primary.main
            },
        },



    }))

}

